import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Campus } from 'src/app/core/models/api/campus.model';
import { CampusService } from 'src/app/core/services/api/campus.service';

@Component({
    selector: 'app-faq',
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {

    public campus       : Campus;
    public editionId    : number;
    public webResourceId: string = "faq-page";
    
    constructor(private activatedRoute: ActivatedRoute, private campusService: CampusService) { }
    
    ngOnInit() { 

        this.campus = this.campusService.campusActive;
        this.getEditionFromRoute();
        
    }
    
    private getEditionFromRoute() {

        this.activatedRoute.paramMap.subscribe(params => {
            
            this.editionId = +params.get("editionId");

        });

    }

}
